import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { checkIfEmailIsValid, checkIfUrlIsValid } from 'utils/functions/formValidation';
import { fetchAddOrEditCompanySubmission } from 'modules/companies/actions';
import { resetCompanyProfilesList } from 'modules/common/actions';
import AddCompanyComponent from 'modules/companies/components/AddCompanyComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddCompanyContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    name: '',
    description: '',
    longDescription: '',
    email: '',
    url: '',
  });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    name: true,
    description: true,
    longDescription: true,
    email: true,
    url: true,
  });
  const [shouldShowErrorMessage, setShouldShowErrorMessage] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const addOrEditCompanySuccessCallback = () => {
    dispatch(resetCompanyProfilesList());
    navigate('/companies');
  };

  const addOrEditCompanyFailCallback = () => {
    setShouldShowErrorMessage(true);
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;

    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;

      return fieldsObj;
    });
  };

  const handleAddOrEditCompanyBtnClick = () => {
    let isEmailValid = true;
    let isUrlValid = true;
    let isFormValid = true;

    if (
      !formFieldsValues.name ||
      !formFieldsValues.description ||
      !formFieldsValues.longDescription ||
      !formFieldsValues.email ||
      !formFieldsValues.url
    ) {
      setFormFieldsValidation({
        name: !!formFieldsValues.name,
        description: !!formFieldsValues.description,
        longDescription: !!formFieldsValues.longDescription,
        email: !!formFieldsValues.email,
        url: !!formFieldsValues.url,
      });
      isFormValid = false;
    }

    if (checkIfEmailIsValid(formFieldsValues.email) === false) {
      isEmailValid = false;
      isFormValid = false;
    }
    setFormFieldsValidation(prevState => ({
      ...prevState,
      email: isEmailValid,
    }));

    if (checkIfUrlIsValid(formFieldsValues.url) === false) {
      isUrlValid = false;
      isFormValid = false;
    }
    setFormFieldsValidation(prevState => ({
      ...prevState,
      url: isUrlValid,
    }));

    if (isFormValid === false) return;

    setFormFieldsValidation({
      name: true,
      description: true,
      longDescription: true,
      email: true,
      url: true,
    });

    const body = {
      data: {
        name: formFieldsValues.name,
        description: formFieldsValues.description,
        longDescription: formFieldsValues.longDescription,
        email: formFieldsValues.email,
        websiteUrl: formFieldsValues.url,
      },
      callbackActionSuccess: addOrEditCompanySuccessCallback,
      callbackActionFail: addOrEditCompanyFailCallback,
    };

    dispatch(fetchAddOrEditCompanySubmission(body));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AddCompanyComponent
      formFieldsValues={formFieldsValues}
      formFieldsValidation={formFieldsValidation}
      shouldShowErrorMessage={shouldShowErrorMessage}
      handleTextInputFieldChange={handleTextInputFieldChange}
      handleAddOrEditCompanyBtnClick={handleAddOrEditCompanyBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AddCompanyContainer.propTypes = {};

AddCompanyContainer.defaultProps = {};

export default AddCompanyContainer;
